/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoints, Infer } from 'shared';

import { ApiClient } from '../types/api/ApiClient';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SetupApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchProgress = () => {
    return this.api.get<Infer<typeof Endpoints.GetSetupProgress>['Response'][200]>('/setup/progress');
  };
}

export const SetupApiService = new SetupApiServiceClass();
